import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewMotivoComedero = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'motivo_comedero',
        name: 'Motivo Comedero',
        component: ViewMotivoComedero,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
